<template lang="pug">
main.page
	include ../includes/header-basic-business.pug
	section.welcome
		.container.pb-5
			.row
				.col-sm-6.col-12
					img.portrait.border-round-sm(src="images/crossfit-portada.jpg" , attr-animate="3")
				.col-sm-6.col-12
					.card-page(attr-animate="1")
						.mt-5
							h1(attr-animate="3").mb-4 Crossfit
							h6(attr-animate="4").mb-4 Administra tu Box
							p(attr-animate="5").lead.mb-4 Controla pagos y asistencias, publica el WOD, registra PRs y Benchmarks de tus alumnos y mucho más.
							button(type='button', data-toggle='modal', data-target='#demo' , attr-animate="6").btn.btn-primary.mb-3 Solicita tu demo
							small(attr-animate="7").hint.hint-text.d-block Prueba 30 días gratis
					span.scroll-down(attr-animate="10")
						small Scroll para avanzar
						i.arrow

	include ../includes/benefits.pug

</template>

<script>

	export default {
		name: 'crossfit',
	}

</script>